module.exports = new __parcel__URL__("welcome-to-project-pages-spork-rebranding-dark.a7e189fa.svg").toString();